<script lang="ts" setup>
import AwakeningMedal from "@/components/AwakeningMedal.vue";
import BaseCard from "@/components/BaseCard.vue";
import BaseHighlight from "@/components/BaseHighlight.vue";
import CharacterThumbnail from "@/components/CharacterThumbnail.vue";
import { usePage } from "@inertiajs/vue3";
import _ from "lodash";
import { onBeforeMount, ref } from "vue";

const page = usePage();
const props = defineProps<{
  awakeningPath: object[];
}>();

const ezaMedals = ref<object>({});

onBeforeMount(() => {
  if (_.isEmpty(ezaMedals.value)) {
    props.awakeningPath.forEach((awakening: object) => {
      if (awakening.eza_type !== 1) {
        return;
      }

      awakening.awakening_items.forEach((awakeningMedal: object) => {
        if (ezaMedals.value[awakeningMedal.item_id]) {
          ezaMedals.value[awakeningMedal.item_id].quantity +=
            awakeningMedal.quantity;
        } else {
          ezaMedals.value[awakeningMedal.item_id] = awakeningMedal;
        }
      });
    });
  }
});

function typeImage(type: string, ezaType: number = 0): string {
  let img = "";

  switch (type) {
    case "Z":
    default:
      img = "z";
      break;
    case "Dokkan":
      img = "dokkan";
      break;
    case "Extreme Z":
      img = ezaType === 2 ? "super_optimal" : "kyokugen";
      break;
  }
  return `${page.props.app.cdn_url}/assets/en/layout/en/image/dokkan/dok_img_${img}.png`;
}
</script>

<template>
  <BaseCard
    v-if="awakeningPath.length > 0"
    class="items-center !gap-0 divide-y divide-green-900/75 !p-0"
  >
    <template #heading>Awakening Path</template>

    <div
      v-for="(awakening, i) in awakeningPath.filter(
        (awakening) => !(awakening.eza_type === 1 && awakening.eza_step > 1),
      )"
      :key="awakening.id"
      class="flex w-full flex-col items-center gap-2 p-4"
    >
      <div class="flex flex-row items-center justify-center gap-1">
        <CharacterThumbnail
          :character="awakening.character"
          class="mx-2"
          scale="sm"
        />

        <i-fa6-solid-chevron-right />

        <img
          :alt="awakening.type"
          :src="typeImage(awakening.type, awakening.eza_type)"
          class="h-fit shrink"
        />

        <i-fa6-solid-chevron-right />

        <CharacterThumbnail
          :character="awakening.awakened_character"
          class="mx-2"
          scale="sm"
        />
      </div>

      <div class="flex flex-row gap-2">
        <div v-if="awakening.eza_type === 1" class="flex flex-row gap-2">
          <div
            v-for="ezaMedal in ezaMedals"
            class="flex flex-col items-center gap-1 text-sm"
          >
            <AwakeningMedal :awakening-medal="ezaMedal.item" :scale="0.45" />
            <span
              >x<BaseHighlight>{{ ezaMedal.quantity }}</BaseHighlight></span
            >
          </div>
        </div>

        <div
          v-for="awakeningMedal in awakening.awakening_items"
          v-else
          class="flex flex-col items-center gap-1 text-sm"
        >
          <AwakeningMedal
            :key="`${awakeningMedal}`"
            :awakening-medal="awakeningMedal.item"
            :scale="0.45"
          />
          <span
            >x<BaseHighlight>{{ awakeningMedal.quantity }}</BaseHighlight></span
          >
        </div>
      </div>
    </div>
  </BaseCard>
</template>

<style scoped></style>
